export const taskPanelDefaultSummaryTextLength = 250;
